var modal = require('../modal-static');
var template = require('../../js/template');
var html = document.documentElement;

function show(ev) {
  var localModal = ev.target.closest('[data-cm-modal-btn]');
  if (localModal) {
    ev.preventDefault()
    var modalHTML = document.getElementById(localModal.dataset.cmModalBtn);
    var fragment = modalHTML.cloneNode(true);
    fragment.hidden = false;
    modal.set(fragment);
    modal.modelHeightCheck();
  }
}

// Only if there are supplied link modals show
document.addEventListener('click', show)
